export function decodeHtmlEntities(input: string): string {
  if (!input) return '';
  const textArea = document.createElement('textarea');
  textArea.innerHTML = input;
  return textArea.value;
}

export function truncateText(text: string, maxLength: number): string {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}…`;
}
